module.exports = __webpack_public_path__ + "img/loughborough.d20ba6eb.png";